/** Formateadores y etiquetas de presentación de Locaciones (US-2.2, es-CO). */
import type { LocationStatus, LocationSyncStatus } from '@goelectric/shared-types';

export const LOCATION_STATUS_LABELS: Record<LocationStatus, string> = {
  ACTIVE: 'Activa',
  INACTIVE: 'Dada de baja',
};

export const LOCATION_SYNC_STATUS_LABELS: Record<LocationSyncStatus, string> = {
  PENDIENTE: 'Pendiente',
  SYNCED: 'Sincronizada',
  ERROR: 'Error de sincronización',
};

/** Coordenadas para presentación (`lat, lng`); `—` si no vienen. */
export function formatCoordinates(
  coordinates?: { latitude: number; longitude: number } | null,
): string {
  if (!coordinates) {
    return '—';
  }
  return `${coordinates.latitude}, ${coordinates.longitude}`;
}

/** Fecha/hora corta local (es-CO) para el detalle. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString('es-CO', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
